import User from "@/models/User.js";

const user = new User();
const userInfo = JSON.parse(localStorage.getItem("userInfo"));
const cartoTableName = process.env.VUE_APP_CARTO_TABLE;

export default {
	apiKey: process.env.VUE_APP_CARTODB_TOKEN,
	username: "servinformacion",
	serverUrl: "https://cartodr2.sitimapa.co/user/servinformacion",
	cartoTable: userInfo ? `${cartoTableName}_${userInfo.datarutas_company_id}` : "cerberus_dev_1",
};
